import { render, staticRenderFns } from "./toDoStatisticsList.vue?vue&type=template&id=c0f87b32&scoped=true"
import script from "./toDoStatisticsList.vue?vue&type=script&lang=js"
export * from "./toDoStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./toDoStatisticsList.vue?vue&type=style&index=0&id=c0f87b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f87b32",
  null
  
)

export default component.exports